import { useCallback, useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { MdCheck, MdOutlineCopyAll } from "react-icons/md";
import { useLanguage } from "../Translations/LenguageContext";

const InfoModalAbilities = ({
    show,
    handleClose,
    selectedAbility
}) => {
    const {t} = useLanguage()
    const [checkCopy, setCheckCopy] = useState(false)

    const copyItem = (item) => {
        navigator.clipboard.writeText(item)
            .then(() => {
                setCheckCopy(true);
                setTimeout(() => {
                    setCheckCopy(false);
                }, 2000);
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    return (
        <Modal show={show} centered onHide={handleClose}>
            <div className="modal_header">
                <p className="modal_header_title">
                    {selectedAbility?.name}
                </p>
                <img className="ability_icon fade-in" src={selectedAbility?.icon} />
            </div>
            <p className="modal_header_title_description">{selectedAbility?.description}</p>
            {selectedAbility.status == "available" && (
                <p className="modal_header_title_description">{selectedAbility.name} {t.directory.verified}</p>
            )}
            {selectedAbility.status == "verifying" && (
                <p className="modal_header_title_description">{t.directory.not_verified}</p>
            )}


            <div className="modal_main_cont">
                {selectedAbility?.annotation && (
                    <p className="modal_main_cont_description" dangerouslySetInnerHTML={{__html: selectedAbility?.annotation}}></p>
                )}

                {selectedAbility?.source_url && (
                    <div className="persona_reg">
                        <div className="label_input">
                            <label className="input_label">{t.abilities.source_url}</label>
                            <p className="register_form_first register_form_first_disabled fade-in" onClick={() => copyItem(selectedAbility.source_url)}><span>{selectedAbility?.source_url}</span> {checkCopy ? <i className="fade-in"> <MdCheck /></i> : <i className="fade-in"><MdOutlineCopyAll /></i>}</p>
                        </div>
                    </div>
                )}
            </div>



            <div className="modal_footer">
                <div className="modal_footer_err_cont">

                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={handleClose}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default InfoModalAbilities;